import React from 'react';
import { Typography } from 'antd';
import cn from 'classnames';
import styles from './BlockHeader.module.scss';

const { Title, Text } = Typography;

const BlockHeader = ({ icon, title, description, as = 'div', className }) => {
  const Component = as;

  return (
    <Component className={cn(styles.root, className)}>
      <div className={styles.iconWrap}>{icon}</div>
      <div className={styles.contentWrap}>
        <Title level={2} className={styles.title}>
          {title}
        </Title>
        {description && <Text>{description}</Text>}
      </div>
    </Component>
  );
};

export default BlockHeader;
